"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTokenOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var CTokenOracleFactory = /** @class */ (function (_super) {
    __extends(CTokenOracleFactory, _super);
    function CTokenOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    CTokenOracleFactory.prototype.deploy = function (_cTokenAddress, _chainLinkTokenAggregator, _chainLinkEthAggregator, overrides) {
        return _super.prototype.deploy.call(this, _cTokenAddress, _chainLinkTokenAggregator, _chainLinkEthAggregator, overrides || {});
    };
    CTokenOracleFactory.prototype.getDeployTransaction = function (_cTokenAddress, _chainLinkTokenAggregator, _chainLinkEthAggregator, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _cTokenAddress, _chainLinkTokenAggregator, _chainLinkEthAggregator, overrides || {});
    };
    CTokenOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    CTokenOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    CTokenOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return CTokenOracleFactory;
}(contracts_1.ContractFactory));
exports.CTokenOracleFactory = CTokenOracleFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_cTokenAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_chainLinkTokenAggregator",
                type: "address",
            },
            {
                internalType: "address",
                name: "_chainLinkEthAggregator",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "cToken",
        outputs: [
            {
                internalType: "contract ICToken",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainLinkEthAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainLinkTokenAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainlinkEthScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainlinkTokenScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "precisionScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=CTokenOracleFactory.js.map